// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Row, Col, Form } from "react-bootstrap";
// import { BsPencil, BsCheck, BsX } from "react-icons/bs";
// const InstanceView = ({ instanceData, setInstanceDetails }) => {
//     const [isEditMode, setIsEditMode] = useState(false);
//     const [editedInstanceData, setEditedInstanceData] = useState(instanceData);
//     const [setupIdError, setSetupIdError] = useState('');
//     const [isSetupIdEditing, setIsSetupIdEditing] = useState(false);
//     const [editField, setEditField] = useState(null);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         if (name === 'setup_id') {
//             setIsSetupIdEditing(true);
//         }
//         setEditedInstanceData((prevState) => ({
//             ...prevState,
//             [name]: value,
//         }));
//     };

//     const handleSave = async () => {
//         if (isSetupIdEditing) {
//             setSetupIdError('');
//         }
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             await axios.put(`${backendUrl}/api/instance-info/${instanceData.id}`, editedInstanceData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });
//             setInstanceDetails((prevDetails) => ({
//                 ...prevDetails,
//                 ...editedInstanceData, // Update only the changed fields
//             }));
//             setEditField(null);        
//         } catch (error) {
//             if (error.response?.data?.errors?.setup_id) {
//                 setSetupIdError(error.response.data.errors.setup_id[0]);
//             } else {
//                 console.error('Error saving instance details:', error);
//             }
//         }
//     };

//     // Fields configuration
//     const fields = [
//         { name: 'setup_name', label: 'Setup Name', type: 'text' },
//         { name: 'setup_id', label: 'Setup ID', type: 'text' },
//         { name: 'setup_mode', label: 'Setup Mode', type: 'select',  options: [{ value: "single", label: "Single" }, { value: "multi", label: "Multi" },] },
//         { name: 'setup_type', label: 'Setup Type', type: 'select', options:[{ value: "direct", label: "Direct" }, { value: "partner", label: "Partner" }, { value: "R&D", label: "R&D" },] },


//         { name: 'max_tenants', label: 'Max Tenants', type: 'number' },
//         { name: 'key', label: 'Key', type: 'text' , readOnly: true},

//         { name: 'max_process', label: 'Max Process', type: 'number' },
//         { name: 'address', label: 'Address', type: 'text' },
//         { name: 'remarks', label: 'Remarks', type: 'text' },
//         { name: 'active_status', label: 'Status', type: 'select', options: [{ value: "active", label: "Active" }, { value: "inactive", label: "Inactive" }, { value: "suspended", label: "Suspended" },] },

//         { name: 'contact_type', label: 'Contact Type', type: 'select', options: [{ value: "owner", label: "Owner" }, { value: "partner", label: "Partner" },] },
//         { name: 'partner_name', label: 'Partner Name', type: 'text' },



//     ];

//     const visibleFields = fields.filter((field) => {
//         if (field.name === "partner_name") {
//             return editedInstanceData.setup_type === "partner";
//         }
//         return true; // Keep all other fields
//     });


//     // Group fields into rows (3 fields per row)
//     const rows = [];
//     for (let i = 0; i < visibleFields.length; i += 3) {
//         rows.push(visibleFields.slice(i, i + 3));
//     }




//       return (
//                 <div className="p-3 font-size-13">
//                     <Row>
//                         {visibleFields.map((field, index) => (
//                             <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
//                     <strong className="view-label">
//                     {field.label}:
//                                 </strong>
//                                 <div className="editable-container d-flex align-items-center">
//                                     {editField === field.name ? (
//                                         <div className="d-flex align-items-center">
//                                             {field.type === "select" ? (
//                                                 <Form.Select
//                                                     name={field.name}
//                                                     value={editedInstanceData[field.name] || ""}
//                                                     onChange={handleChange}
//                                                     autoFocus
//                                                     className="form-control form-feild"
//                                                     >
//                                                     <option value="">Select</option>
//                                                     {field.options.map((option) => (
//                                                         <option key={option.value} value={option.value}>
//                                                             {option.label}
//                                                         </option>
//                                                     ))}
//                                                 </Form.Select>
//                                             ) : (
//                                                 <Form.Control
//                                                     type="text"
//                                                     name={field.name}
//                                                     value={editedInstanceData[field.name] || ""}
//                                                     onChange={handleChange}
//                                                     autoFocus
//                                                     className="form-control form-feild"
//                                                     />
//                                             )}
//                                             <BsCheck className="text-success mx-2" onClick={handleSave} style={{ cursor: "pointer" }} />
//                                             <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
//                                         </div>
//                                     ) : (
//                                         <div className="hover1" onClick={() => !field.readOnly && setEditField(field.name)}>
//                                         <span className="hover-field1">
//                                             {editedInstanceData[field.name] || "-"} 
//                                         </span>
//                                         {!field.readOnly && <BsPencil className="text-primary pencil-icon1" />}
//                                     </div>

//                                     )}
//                                 </div>
//                             </Col>
//                         ))}
//                     </Row>
//                 </div>
//             );

// };

// export default InstanceView;


import React, { useState, useEffect } from 'react';
import { Row, Col, Card } from "react-bootstrap";
import { 
    FaServer, 
    FaIdCard, 
    FaCog, 
    FaUsers, 
    FaKey, 
    FaMapMarkerAlt,
    FaStickyNote,
    FaUserTag,
    FaBuilding,
    FaShieldAlt,
    FaInfoCircle,
    FaGlobe
} from "react-icons/fa";

const InstanceView = ({ instanceData, setInstanceDetails }) => {
    const [editedInstanceData, setEditedInstanceData] = useState(instanceData);

    useEffect(() => {
        setEditedInstanceData(instanceData);
    }, [instanceData]);

    // Helper function to get display value
    const getDisplayValue = (value) => {
        return value || "--";
    };

    // Helper function to format option labels
    const getOptionLabel = (value, options) => {
        if (!value) return "--";
        const option = options?.find(opt => opt.value === value);
        return option ? option.label : value;
    };

    // Field configuration with icons and categories
    const fieldGroups = [
        {
            title: "Basic Information",
            icon: <FaServer className="text-primary" />,
            fields: [
                { 
                    name: 'setup_name', 
                    label: 'Setup Name', 
                    icon: <FaServer size={14} />, 
                    value: getDisplayValue(editedInstanceData?.setup_name) 
                },
                { 
                    name: 'setup_id', 
                    label: 'Setup ID', 
                    icon: <FaIdCard size={14} />, 
                    value: getDisplayValue(editedInstanceData?.setup_id) 
                },
                { 
                    name: 'setup_mode', 
                    label: 'Setup Mode', 
                    icon: <FaCog size={14} />, 
                    value: getOptionLabel(editedInstanceData?.setup_mode, [
                        { value: "single", label: "Single" }, 
                        { value: "multi", label: "Multi" }
                    ]) 
                },
                { 
                    name: 'setup_type', 
                    label: 'Setup Type', 
                    icon: <FaBuilding size={14} />, 
                    value: getOptionLabel(editedInstanceData?.setup_type, [
                        { value: "direct", label: "Direct" }, 
                        { value: "partner", label: "Partner" }, 
                        { value: "R&D", label: "R&D" }
                    ]) 
                },
                { 
                    name: 'ip_address', 
                    label: 'IP Address', 
                    icon: <FaGlobe size={14} />, 
                    value: getDisplayValue(editedInstanceData?.ip_address) 
                }
            ]
        },
        {
            title: "Capacity & Configuration",
            icon: <FaUsers className="text-info" />,
            fields: [
                { 
                    name: 'max_tenants', 
                    label: 'Max Tenants', 
                    icon: <FaUsers size={14} />, 
                    value: getDisplayValue(editedInstanceData?.max_tenants) 
                },
                { 
                    name: 'max_process', 
                    label: 'Max Process', 
                    icon: <FaCog size={14} />, 
                    value: getDisplayValue(editedInstanceData?.max_process) 
                },
                { 
                    name: 'key', 
                    label: 'Key', 
                    icon: <FaKey size={14} />, 
                    value: getDisplayValue(editedInstanceData?.key) 
                }
            ]
        },
        {
            title: "Contact & Status",
            icon: <FaUserTag className="text-warning" />,
            fields: [
                { 
                    name: 'contact_type', 
                    label: 'Contact Type', 
                    icon: <FaUserTag size={14} />, 
                    value: getOptionLabel(editedInstanceData?.contact_type, [
                        { value: "owner", label: "Owner" }, 
                        { value: "partner", label: "Partner" }
                    ]) 
                },
                { 
                    name: 'partner_name', 
                    label: 'Partner Name', 
                    icon: <FaUserTag size={14} />, 
                    value: getDisplayValue(editedInstanceData?.partner_name),
                    condition: editedInstanceData?.setup_type === "partner"
                },
                { 
                    name: 'active_status', 
                    label: 'Status', 
                    icon: <FaShieldAlt size={14} />, 
                    value: getOptionLabel(editedInstanceData?.active_status, [
                        { value: "active", label: "Active" }, 
                        { value: "inactive", label: "Inactive" }, 
                        { value: "suspended", label: "Suspended" }
                    ]) 
                }
            ]
        },
        // {
        //     title: "Additional Information",
        //     icon: <FaStickyNote className="text-success" />,
        //     fields: [
        //         { 
        //             name: 'address', 
        //             label: 'Address', 
        //             icon: <FaMapMarkerAlt size={14} />, 
        //             value: getDisplayValue(editedInstanceData?.address) 
        //         },
        //         { 
        //             name: 'remarks', 
        //             label: 'Remarks', 
        //             icon: <FaStickyNote size={14} />, 
        //             value: getDisplayValue(editedInstanceData?.remarks) 
        //         }
        //     ]
        // }
    ];

    return (
        <div className="p-3">
            {/* Instance Header Card */}
            {/* <Card className="mb-4 shadow-sm border-0">
                <Card.Body className="text-center">
                    <div className="d-flex align-items-center justify-content-center mb-3">
                        <div className="bg-primary rounded-circle p-3">
                            <FaServer className="text-white" size={32} />
                        </div>
                    </div>
                    <h4 className="fw-bold text-dark mb-1">{getDisplayValue(editedInstanceData?.setup_name)}</h4>
                    <p className="text-muted mb-2">Setup ID: {getDisplayValue(editedInstanceData?.setup_id)}</p>
                    <div className="d-flex justify-content-center gap-4">
                        <div className="d-flex align-items-center text-muted">
                            <FaCog className="me-2" />
                            <small>{getOptionLabel(editedInstanceData?.setup_mode, [
                                { value: "single", label: "Single" }, 
                                { value: "multi", label: "Multi" }
                            ])}</small>
                        </div>
                        <div className="d-flex align-items-center text-muted">
                            <FaBuilding className="me-2" />
                            <small>{getOptionLabel(editedInstanceData?.setup_type, [
                                { value: "direct", label: "Direct" }, 
                                { value: "partner", label: "Partner" }, 
                                { value: "R&D", label: "R&D" }
                            ])}</small>
                        </div>
                        <div className="d-flex align-items-center text-muted">
                            <FaShieldAlt className="me-2" />
                            <small className="text-capitalize">
                                {getOptionLabel(editedInstanceData?.active_status, [
                                    { value: "active", label: "Active" }, 
                                    { value: "inactive", label: "Inactive" }, 
                                    { value: "suspended", label: "Suspended" }
                                ])}
                            </small>
                        </div>
                    </div>
                </Card.Body>
            </Card> */}

            {/* Instance Details Sections */}
            {fieldGroups.map((group, groupIndex) => {
                // Filter fields based on conditions
                const visibleFields = group.fields.filter(field => 
                    field.condition === undefined || field.condition === true
                );

                if (visibleFields.length === 0) return null;

                return (
                    <Card key={groupIndex} className="mb-4 shadow-sm border-0">
                        <Card.Header className="bg-light border-0 py-3">
                            <div className="d-flex align-items-center">
                                {group.icon}
                                <h5 className="mb-0 ms-2 fw-semibold text-dark">{group.title}</h5>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <Row className="g-0">
                                {visibleFields.map((field, fieldIndex) => (
                                    <Col md={6} key={fieldIndex}>
                                        <div className="p-3 border-bottom border-end instance-detail-item">
                                            <div className="d-flex align-items-start">
                                                <div className="text-muted me-3 mt-1">
                                                    {field.icon}
                                                </div>
                                                <div className="flex-grow-1">
                                                    <label className="text-muted small mb-1 d-block fw-medium">
                                                        {field.label}
                                                    </label>
                                                    <div className="text-dark fw-semibold">
                                                        {field.value}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </Card>
                );
            })}

            {/* System Information Card */}
            {/* <Card className="shadow-sm border-0">
                <Card.Header className="bg-light border-0 py-3">
                    <div className="d-flex align-items-center">
                        <FaInfoCircle className="text-secondary" />
                        <h5 className="mb-0 ms-2 fw-semibold text-dark">System Information</h5>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <div className="mb-3">
                                <label className="text-muted small mb-1 d-block fw-medium">Instance ID</label>
                                <div className="text-dark fw-semibold">
                                    {instanceData?.id || "--"}
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-3">
                                <label className="text-muted small mb-1 d-block fw-medium">Created Date</label>
                                <div className="text-dark fw-semibold">
                                    {instanceData?.created_at ? new Date(instanceData.created_at).toLocaleDateString() : "--"}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card> */}
        </div>
    );
};

export default InstanceView;
